export default class LinkToClipboard {

  constructor() {

    let links = Array.prototype.slice.call(document.querySelectorAll('.js-copy-link'), 0)

    this.linkClickHandler = this.linkClickHandler.bind(this)
    links.forEach((link) => {
      link.addEventListener('click', this.linkClickHandler)
    })
  }

  linkClickHandler(e) {
    e.preventDefault();

    const link = e.currentTarget

    let linkHref = link.getAttribute('href')

    document.createElement('input')
    var input = document.createElement('input');
    input.setAttribute('value', linkHref);

    document.body.appendChild(input);
    input.select();

    var result = document.execCommand('copy');
    document.body.removeChild(input);

    link.classList.add('copied')
    setTimeout(() => {
      link.classList.remove('copied')
    }, 1500)
  }
}